import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

/**
 * Active le mode plein écran en masquant la barre de statut
 * Similaire aux jeux mobiles
 */
export const enableFullscreen = async () => {
    if (!Capacitor.isNativePlatform()) {
        console.log('Fullscreen mode is only available on native platforms');
        return;
    }

    try {
        // Masquer la barre de statut
        await StatusBar.hide();
        console.log('Fullscreen mode enabled');
    } catch (error) {
        console.error('Error enabling fullscreen:', error);
    }
};
